import moment from 'moment'

moment.locale('es')

class RankingFilterService {
  static getFilters (params) {
    let filters = {
      from: this.getStorageStartDate(),
      to: this.getStorageFinishDate(),
      rider: this.getStorageRider()
    }
    if (params) {
      if (params.from && this.isValidDate(params.from)) {
        filters.from = moment(params.from, 'YYYY-MM-DD').toDate()
      }
      if (params.to && this.isValidDate(params.to)) {
        filters.to = moment(params.to, 'YYYY-MM-DD').toDate()
      }
      if (params.rider && Number.isInteger(parseInt(params.rider))) {
        filters.rider = parseInt(params.rider)
      }
    }
    return filters
  }

  static setStorageFilters (filters) {
    let data = {
      'lastSave': moment().format('YYYY-MM-DD'),
      ...filters
    }
    localStorage.setItem('dailyWorkFilters', JSON.stringify(data))
  }

  static isValidDate (date) {
    return moment(date, 'YYYY-MM-DD').isValid()
  }

  static getStorageFilters () {
    let filters = JSON.parse(localStorage.getItem('dailyWorkFilters'))
    let currentDay = moment().format('YYYY-MM-DD')
    return !filters || filters.lastSave !== currentDay ? null : filters
  }

  static getStorageStartDate () {
    let filters = this.getStorageFilters()
    return filters && filters.from ? moment(filters.from, 'YYYY-MM-DD').toDate() : moment().weekday(0).toDate()
  }

  static getStorageFinishDate () {
    let filters = this.getStorageFilters()
    return filters && filters.to ? moment(filters.to, 'YYYY-MM-DD').toDate() : moment().weekday(5).toDate()
  }

  static getStorageRider () {
    let filters = this.getStorageFilters()
    return filters && filters.rider ? filters.rider : null
  }
}

export default RankingFilterService
